import { env } from "./envConfig";
const axios = require("axios");

export const axiosApiInstance = axios.create();

axiosApiInstance.defaults.baseURL = `${env.REACT_APP_BACKEND_APP_NAME}`;
// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async (config: any) => {
    config.headers = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
    };
    return config;
  },
  (error: any) => {
    Promise.reject(error);
  }
);
